var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCarrotLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 24,
    viewBox: "0 0 160 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.0677V12.0006C0 5.40742 5.0477 0.00506483 12.23 0.00506483C16.6009 0.00506483 19.2431 1.49806 21.5125 3.61822L18.836 6.63299C16.9393 4.90975 14.9065 3.75013 12.1956 3.75013C7.65676 3.75013 4.36969 7.39567 4.36969 11.9358V12.0006C4.36969 16.5407 7.65676 20.2522 12.1956 20.2522C15.11 20.2522 16.9736 19.0926 19.0052 17.2374L21.6829 19.8876C19.2087 22.4059 16.4991 23.9961 12.0608 23.9961C5.14946 23.9961 0 18.728 0 12.0677Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1938 5.10888L30.1643 23.5992H25.8951L36.3301 0.236574H40.1922L50.6273 23.5992H46.2232L38.1938 5.10888Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.993 11.9007C69.9747 11.9007 71.8715 10.3765 71.8715 8.0249V7.95774C71.8715 5.47302 70.0422 4.11434 66.9599 4.11434H60.8945V11.9007H66.993ZM56.7255 0.402792H67.2966C70.2784 0.402792 72.6153 1.26501 74.1405 2.72322C75.3935 3.98117 76.1047 5.70441 76.1047 7.72624V7.7922C76.1047 11.6032 73.7665 13.8889 70.4464 14.8171L76.8501 23.5987H71.9373L66.111 15.5138H60.8929V23.5987H56.7255V0.402792Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0833 11.9007C98.0651 11.9007 99.9618 10.3765 99.9618 8.0249V7.95774C99.9618 5.47302 98.1325 4.11434 95.0502 4.11434H88.9849V11.9007H95.0833ZM84.8195 0.402792H95.3894C98.3712 0.402792 100.708 1.26501 102.233 2.72322C103.488 3.98117 104.199 5.70441 104.199 7.72624V7.7922C104.199 11.6032 101.861 13.8889 98.5404 14.8171L104.943 23.5987H100.031L94.2038 15.5138H88.9857V23.5987H84.8195V0.402792Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.722 12.0671V12C130.722 7.49462 127.369 3.74955 122.66 3.74955C117.95 3.74955 114.663 7.42867 114.663 11.9352V12C114.663 16.5077 118.018 20.2516 122.727 20.2516C127.436 20.2516 130.722 16.5737 130.722 12.0671ZM110.294 12.0675V12.0004C110.294 5.47319 115.443 0.00488281 122.728 0.00488281C130.012 0.00488281 135.092 5.40723 135.092 11.9356V12.0004C135.092 18.53 129.943 23.9959 122.66 23.9959C115.375 23.9959 110.294 18.5947 110.294 12.0675Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.278 4.18122H140.756V0.403766H160V4.18122H152.479V23.5985H148.278V4.18122Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCarrotLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/carrot-logo.117e852c05ee315d37388c7dd9515d2a.svg";